var _path, _path2, _rect, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferAFriend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 87,
    viewBox: "0 0 135 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 81H33.1105L79.9056 75.294C88.2084 74.2816 94.0792 66.6738 92.9535 58.3855L90.023 36.809C89.658 34.1213 88.571 31.5828 86.8777 29.4638L69.5476 7.77668C65.7817 3.06391 59.5589 1.06576 53.7533 2.70506L14.5835 13.7653C6.5534 16.0327 1.91715 24.4173 4.2663 32.4238L15.3567 70.223C17.2311 76.6115 23.0922 81 29.75 81Z",
    fill: "url(#paint0_linear)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7686 27.2654L64.1317 15.5143L108.381 2.94336L122.591 52.9639C123.497 56.1515 121.647 59.4697 118.459 60.3752L44.3905 81.4179C41.2029 82.3235 37.8848 80.4735 36.9792 77.286L22.7686 27.2654Z",
    fill: "#C0BFB4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 32.9998,
    width: 78,
    height: 53,
    fill: "white",
    stroke: "#413D45",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7956 67.6532C95.3519 68.1156 94.6396 68.1156 94.2022 67.6532L87.3976 60.5177C85.423 58.4433 85.5418 55.0068 87.7475 53.0948C89.672 51.4265 92.5401 51.7264 94.3022 53.5822L94.9958 54.307L95.6956 53.5759C97.4577 51.7264 100.326 51.4265 102.25 53.0948C104.462 55.0068 104.575 58.4433 102.6 60.5177L95.7956 67.6532Z",
    fill: "#6DA6D4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5746 15.1044L22.7686 27.2654L72.0703 44.2438C73.2578 44.6528 74.5743 44.2788 75.3694 43.3066L108.381 2.94336L65.5746 15.1044Z",
    fill: "#9F9E8F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 46.1228,
    y1: 81,
    x2: 46.1228,
    y2: 11.0046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0EAE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9DFD2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferAFriend);
export default __webpack_public_path__ + "static/media/refer-a-friend.579cfe4cf39b6c0091d333574dd7e5ca.svg";
export { ForwardRef as ReactComponent };